<template>
  <div class="bg-white">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Info Partner</p>
        <div class="mb-6 max-w-sm">
          <TextField type="text" label="ID" :disabled="true" v-model="id" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Nama" v-model="payloads.name" placeholder="Masukan nama user" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Kelamin</label>
          <CustomSelect :options="genderList" v-model="selectedGender" :default="selectedGender" optionLabel="label" placeholder="Pilih jenis kelamin" />
        </div>
        <div class="mb-6">
          <TextField type="number" label="No Handphone" v-model="payloads.phone_number" placeholder="Masukan no handphone" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Role</label>
          <CustomSelect :options="roleList" v-model="selectedRole" :defaultValue="selectedRole" placeholder="Pilih role" optionLabel="name" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Alamat Email" v-model="payloads.email" placeholder="Alamat Email" />
        </div>
      </div>
      <div class="flex-1 mdmax:w-full mdmax:flex-auto">
        <div class="p-6 ">
          <p class="font-bold text-lg mb-6">Buat Akun</p>
          <div class="mb-6">
            <TextField type="text" label="Username" v-model="payloads.username" placeholder="Username" />
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Password</label>
            <div class="relative">
              <TextField :type="passwordState.fieldType" v-model="payloads.password" placeholder="Masukan password" />
              <span class="inline-block cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2" @click="showPassword(passwordState)">
                <component :is="passwordState.icon" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <!-- <Button buttonText="Draft" @action="submit()" type="secondary" :size="isMobile ? 'full' : 'regular'" /> -->
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const EyeOpen = () => import(/* webpackChunkName: "icon" */ '@/components/Icons/EyeOpen')
const EyeClose = () => import(/* webpackChunkName: "icon" */ '@/components/Icons/EyeClose')
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      genderList: [
        {
          label: 'Laki-Laki',
          value: 'M'
        },
        {
          label: 'Perempuan',
          value: 'F'
        }
      ],
      payloads: {
        name: null,
        partner_id: null,
        username: null,
        password: null,
        login_type: 'userpass',
        email: null,
        phone_number: null,
        profile_image: '',
        gender: null,
        role_id: null
      },
      selectedRole: null,
      selectedGender: null,
      id: null,
      passwordState: {
        fieldType: 'password',
        hidden: true,
        icon: EyeOpen
      },
      confirmPasswordState: {
        fieldType: 'password',
        hidden: true,
        icon: EyeOpen
      }
    }
  },
  watch: {
    selectedRole(val) {
      if (val) {
        this.payloads.role_id = val.id
      }
    },
    selectedGender(val) {
      if (val) {
        this.payloads.gender = val.value
      }
    }
  },
  computed: {
    ...mapGetters('role', ['roleList']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    }
  },
  mounted() {
    if (this.mode === 'edit') {
      // this.getPartnerInformartion()
    } else {
      this.getRole()
    }
  },
  methods: {
    ...mapActions('role', ['getRoleList']),
    ...mapActions('admin', ['createAdmin']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getRole() {
      this.getRoleList({
        params: {
          page: 1,
          per_page: 50,
          search_keyword: ''
        }
      })
        .then(res => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    showPassword(field) {
      field.hidden = !field.hidden
      if (field.hidden) {
        field.fieldType = 'password'
        field.icon = EyeOpen
      } else {
        field.fieldType = 'text'
        field.icon = EyeClose
      }
    },
    submit() {
      let self = this
      this.showLoading()
      this.payloads.partner_id = this.partnerId
      this.createAdmin({
        payloads: this.payloads
      }).then(() => {
        this.hideLoading()
        const promise = new Promise((resolve, reject) => {
          self.setToast({
            options: { type: 'success', duration: 3000, primaryText: 'Penambahan User Berhasil', secondaryText: 'Data telah kami simpan' }
          })
          resolve()
        })
        promise.then(() => {
          this.$router.push('/user')
        })
      })
    }
  }
}
</script>
